/*eslint-disable */
var interval;

import 'vue-datetime/dist/vue-datetime.css';
import 'moment-timezone';

import Multiselect from 'vue-multiselect';
import VueDatetimeJs from 'vue-datetime-js';
import { bus } from '@/main';
import countries from '@/services/country.json';
import demoReqAlreadyScheduledPopup from '@/components/public/demo-req-already-scheduled-popup/';
import moment from 'moment';
import toast from '@/services/toast';

var $ = window.jQuery = require('jquery');
export default {
  name: 'request-for-demo-popup',
  components: {
    Multiselect,
    datePicker: VueDatetimeJs,
    'demo-req-already-scheduled-popup': demoReqAlreadyScheduledPopup
  },
  props: [
  ],
  data() {
    return {
      first_name: '',
      last_name: '',
      email: '',
      phone_no: '',
      company_name: '',
      num_of_attendees: '',
      country: '',
      city: '',
      live_demo_site: '',
      actvSlide: false,
      submitted: false,
      sectionHide: false,
      select_option: 'company',
      minDatetime: this.getTomorrowDate(),
      countryList: [],
      slotTimeList: null,
      slotTimeListArr: [],
      demoReqFormConfirmationState: false,
      selectedTimeZone: '',
      selectedTimeSlot: '',
      selectedTimeSlotIndex: '',
      isClickOutsideEnabledOfC: false,
      isClickOutsideEnabledOfZone: false,
      isClickOutsideEnabledOfSlot: false,
      demoReqFirstScreenState: true,
      otp: '',
      countDown: 600,
      displayTimes: '10:00',
      demoReqAlreadyScheduledPopupState: false,
      datetimeConfig: ['Sunday', 'Saturday'],
      bookedSlots:[]
    }
  },
  computed: {
  },
  mounted() {
    setTimeout(() => {
      this.actvSlide = true
    }, 800)
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key],
        value: key
      })
    });
    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
    this.$store.dispatch('getTimeSlotsWithZoneAction').then((res) => {
      this.slotTimeList = res.data.timezones;
      if (!this.slotTimeList) return;
      this.slotTimeListArr = Object.entries(this.slotTimeList).map(([name, value]) => ({ name, value }));
    });
    bus.$on('demoReqAlreadyScheduledPopupStateBus', (data) => {
      this.demoReqAlreadyScheduledPopupState = data;
    });
    this.$store.dispatch('alreadyBookedSlotListAction').then((res) => {
        this.bookedSlots = res.data.data.booked_slots;
    });
  },
  methods: {
    getTomorrowDate() {
        const today = new Date();
        const tomorrow = new Date(today); 
        tomorrow.setDate(today.getDate() + 1); 
        const year = tomorrow.getFullYear();
        const month = String(tomorrow.getMonth() + 1).padStart(2, '0');
        const day = String(tomorrow.getDate()).padStart(2, '0');
        const formattedTomorrow = `${year}-${month}-${day}`;
        return formattedTomorrow;
    },
    disabledBookedSlotsMethod(slots) {
        const timezoneMap = {
            'IST': 'Asia/Kolkata',
            'JST': 'Asia/Tokyo',
            'GMT': 'Europe/London',
            'BST': 'Europe/London',
            'EDT': 'America/New_York',
            'CDT': 'America/Chicago',
            'PDT': 'America/Los_Angeles',
            'CST': 'America/Chicago',
            'ART': 'America/Argentina/Buenos_Aires',
        };

        const targetDate = this.live_demo_site;
        const targetTimezoneAbbr = this.selectedTimeZone.name;

        const targetIANA = timezoneMap[targetTimezoneAbbr] || targetTimezoneAbbr;

        const bookedUTCSeconds = this.bookedSlots.map(slot => {
            const dateTimeString = `${slot.date} ${slot.user_timeslot}`;
            const bookedTimezoneAbbr = slot.user_timezone;
            const bookedIANA = timezoneMap[bookedTimezoneAbbr] || bookedTimezoneAbbr;
            const utcMoment = moment.tz(dateTimeString, 'YYYY-MM-DD HH:mm', bookedIANA);
            return utcMoment.utc().format('YYYY-MM-DD HH:mm');
        });

        const nowUTC = moment.utc();
        const twentyFourHoursFromNowUTC = nowUTC.add(24, 'hours');

        const available_slots = slots.filter(slotTime => {
            const currentDateTimeString = `${targetDate} ${slotTime}`;
            const currentSlotMoment = moment.tz(currentDateTimeString, 'YYYY/MM/DD HH:mm', targetIANA);
            
            const currentSlotUTCMoment = currentSlotMoment.utc();
            
            const currentSlotUTCKey = currentSlotUTCMoment.format('YYYY-MM-DD HH:mm');
            const isBooked = bookedUTCSeconds.includes(currentSlotUTCKey);
            
            const isTooSoon = currentSlotUTCMoment.isSameOrBefore(twentyFourHoursFromNowUTC);
            
            return !isBooked && !isTooSoon;
        });

        return available_slots;
    },
    countDownTimer() {
      if (this.countDown > 0) {
        interval = setTimeout(() => {
          this.countDown -= 1;
          const minutes = Math.floor(this.countDown / 60);
          const remainingSeconds = this.countDown % 60;
          this.displayTimes = minutes.toString().padStart(2, '0') + ':' + remainingSeconds.toString().padStart(2, '0');
          this.countDownTimer();
        }, 1000);
      }
    },
    backToFirstScreenMethod() {
      var firstSection = document.getElementsByClassName('slide_actv');
      firstSection[0].click();
    },
    scrollBackOfDemoReqMethod() {
      bus.$emit('moveToFirstInSliderBus', true);
    },
    enabledScrollContryFieldMethod() {
      if (this.isClickOutsideEnabledOfC) {
        bus.$emit('movingFlagStateBus', false);
        this.isClickOutsideEnabledOfC = false;
      }
    },
    enabledScrollZoneFieldMethod() {
      if (this.isClickOutsideEnabledOfZone) {
        bus.$emit('movingFlagStateBus', false);
        this.isClickOutsideEnabledOfZone = false;
      }
    },
    enabledScrollSlotFieldMethod() {
      if (this.isClickOutsideEnabledOfSlot) {
        bus.$emit('movingFlagStateBus', false);
        this.isClickOutsideEnabledOfSlot = false;
      }
    },
    disabledScrollContryFieldMethod() {
      bus.$emit('movingFlagStateBus', true);
      this.isClickOutsideEnabledOfC = true;
    },
    disabledScrollZoneFieldMethod() {
      bus.$emit('movingFlagStateBus', true);
      this.isClickOutsideEnabledOfZone = true;
    },
    disabledScrollSlotFieldMethod() {
      bus.$emit('movingFlagStateBus', true);
      this.isClickOutsideEnabledOfSlot = true;
    },
    clearFieldsMethod() {
      this.first_name = '';
      this.last_name = '';
      this.email = '';
      this.phone_no = '';
      this.city = '';
      this.country = '';
      this.live_demo_site = '';
      this.num_of_attendees = '';
      this.company_name = '';
      this.select_option = 'company';
      this.$validator.reset();
      this.selectedTimeSlot = '';
      this.selectedTimeZone = '';
      this.otp = "";
      this.clearTimeOutMethod();
    },
    clearTimeOutMethod() {
      clearInterval(interval);
      this.displayTimes = '10:00';
      this.countDown = 600;
    },
    demoReqFormConfirmationMethod() {
      this.clearFieldsMethod();
      this.demoReqFormConfirmationState = false;
      this.demoReqFirstScreenState = true;

    },
    resentOTPGenerateMethod() {
      let data = {
        email: this.email,
      }
      this.$store.dispatch('otpGenerateForDemoReqAction', data).then((res) => {
        toast.success(res.data.msg || 'Request processed successfully.');
        this.clearTimeOutMethod();
        this.countDownTimer();
      })
    },
    otpGenerateForDemoReqMethod() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true
          let data = {
            email: this.email,
          }
          this.$store.dispatch('otpGenerateForDemoReqAction', data)
            .then((res) => {
              this.countDownTimer();
              this.submitted = false;
              toast.success(res.data.msg || 'Request processed successfully.');
              this.demoReqFirstScreenState = false;
            }).catch((err) => {
              this.submitted = false;
              if (err.status === 400) {
                this.demoReqAlreadyScheduledOpenMethod();
              }
            })
          return;
        }
      })
    },
    demoForRequestSubmitMethod() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true
          let data = {
            title: this.select_option,
            fname: this.first_name,
            lname: this.last_name,
            otp: this.otp,
            mobile: this.phone_no,
            email: this.email,
            city: this.city,
            country: this.country.value,
            date: moment(this.live_demo_site).format('YYYY-MM-DD'),
            time: this.handleSelect(this.selectedTimeSlot),
            num_of_attendees: this.num_of_attendees,
            company_name: this.company_name,
            timezone: this.selectedTimeZone.name,
            timeslot: this.selectedTimeSlot
          }
          this.$store.dispatch('requestForDemoAction', data)
            .then((res) => {
              toast.success(res.data.msg || 'Request processed successfully.');
              this.submitted = false;
              this.demoReqFormConfirmationState = true;
            }).catch((err) => {
              this.submitted = false
              toast.error(err.data.user_msg || err.data.msg);
            })
          return;
        }
      })
    },
    handleSelect(selectedValue) {
      const localNow = moment();
      const timePart = localNow.format(selectedValue);
      const datePart = moment(this.live_demo_site).format('YYYY-MM-DD');
      const desiredFormatTimestamp = `${datePart} ${timePart}`;
      return desiredFormatTimestamp;
    },
    demoReqAlreadyScheduledOpenMethod() {
      this.demoReqAlreadyScheduledPopupState = true;
      document.body.classList.add('demo_req_already_scheduled_popup');
    }
  },
  watch: {
    country(newVal, oldVal) {
      if (newVal) {
        this.enabledScrollContryFieldMethod();
      }
    },
    selectedTimeZone(newVal, oldVal) {
      if (newVal) {
        this.enabledScrollZoneFieldMethod();
      }
    },
    selectedTimeSlot(newVal, oldVal) {
      if (newVal) {
        this.enabledScrollSlotFieldMethod();
      }
    }
  },
}